import React, { useRef, useEffect, useState } from 'react';
import emailjs from '@emailjs/browser';
import ContactCarousel from '../components/Vision Carousel';
const Contact = () => {
 let [successMessage, setSuccessMessage] = useState(false);
        let [errorMessage, setErrorMessage] = useState(false);
        let [sendingMessage, setSendingMessage] = useState(false);

let sendFunc =()=>{
  setSendingMessage(true);
    setSuccessMessage(false);
    setErrorMessage(false);
  
}


  useEffect(()=>{
document.title = 'Contact Us | Bandeko Uganda Limited';

},[]);

    const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_kc28pz2', 'template_r9szf4b', form.current, 'Uik2IVaMZv9p13c5U')
      .then((result) => {
          // console.log(result.text);
          // console.log('Message Sent');
          if(result){
setSuccessMessage(true);
          setSendingMessage(false);

              setTimeout(() => {
            setSuccessMessage(false);
        }, 3000);

         }




      }, (error) => {
          // console.log(error.text);
           if (error){
setErrorMessage(true);
          setSendingMessage(false);
           setTimeout(() => {
           setErrorMessage(false);
        }, 3000);

          }
      });
  };
  return (
    <section className='section-cover contact-cover' >
      <h2 className="home-h2 ">Write To Us</h2>
         <div className='content-container contact-section'>

<div className='form-cover'>
  {/* <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Contact Number</label>
      <input type="number" name="user_number" />
      <label>Subject</label>
      <input type="text" name="user_subject" />


      <label>Message</label>
      <textarea name="message" />
      <input type="submit" value="Send" />
    </form> */}
    <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Contact Number</label>
      <input type="number" name="user_contact" />
      <label>Subject</label>
      <input type="text" name="user_subject" />


      <label>Message</label>
      <textarea name="message" />
       <div  className={`${sendingMessage?'success-box':'hide'}`}><p>Sending...</p></div>
      <div  className={`${successMessage?'success-box':'hide'}`}><p>Thank you! Your message has been sent.</p></div>
      <div className={`${errorMessage?'error-box':'hide'}`}><p>Oh, sorry! An error occurred.</p></div>
      <input type="submit" value="Send Message" onClick={sendFunc} />
    </form>
</div>
           <div className='contact-slides'> 
<ContactCarousel></ContactCarousel>
</div>

         </div>

    </section>
  )
}

export default Contact